import React, { forwardRef } from 'react';

import { Text } from '@thinkific/chalk/react-components';

import * as css from './HorizontalDivider.css';

export const HorizontalDivider = forwardRef<HTMLDivElement, { text: string; hidden?: boolean }>(
  function Divider({ text, hidden }: { text: string; hidden?: boolean }, ref) {
    return (
      <div className={hidden ? css.hiddenHorizontalDivider : css.horizontalDivider} ref={ref}>
        <Text as="span" color="onLight.text.tertiary" variant="body.sm">
          {text}
        </Text>
      </div>
    );
  }
);
